import {
  VoiceControlsContainer,
  VoiceDeviceCardRefreshButton,
} from "./components";
import { canShowRefreshIcon, getModelName } from "../utils";
import {
  getDevice,
  getUserDeviceState,
  initDeviceDetails,
} from "../redux/devices-slice";
import {
  getSelectedDeviceData,
  selectDevice,
} from "../redux/voiceControl-slice";
import { useDispatch, useSelector } from "react-redux";
import { Alert } from "../components";
import cn from "classnames";
import { deviceSettingsError } from "./DeviceSettings.module.scss";
import { headerContainer } from "./VoiceControlsPageMobile.module.scss";
import sharedStyles from "../shared.module.scss";
import { useEffect } from "react";
import { useFormatMessage } from "../i18n";
import { useParams } from "react-router-dom";
import { voiceConfigPage } from "./VoiceConfigPage.module.scss";

export function VoiceControlsPageMobile() {
  const { cloudId } = useParams();
  const dispatch = useDispatch();
  const tr = useFormatMessage();
  const deviceSelected = useSelector(getSelectedDeviceData);
  const { userDeviceError } = useSelector(getUserDeviceState);

  useEffect(() => {
    dispatch(initDeviceDetails());
    dispatch(getDevice(cloudId)).then((data) => {
      if (data.payload.cloudId) dispatch(selectDevice(data.payload));
    });
  }, [cloudId, dispatch]);

  const showRefreshIcon = canShowRefreshIcon(deviceSelected);

  const title =
    deviceSelected.status !== "unselected"
      ? getModelName(deviceSelected.model, deviceSelected.friendly_name)
      : tr("device_unselected_title");

  return (
    <div className={cn(sharedStyles.content, voiceConfigPage)}>
      <div
        className={cn(
          sharedStyles.headerContainer,
          sharedStyles.content,
          headerContainer
        )}
      >
        {showRefreshIcon && (
          <VoiceDeviceCardRefreshButton cloudId={deviceSelected.cloudId} />
        )}
        <h1 className={sharedStyles.pageTitle}>{title}</h1>
      </div>
      {userDeviceError && (
        <Alert severity="error" className={deviceSettingsError}>
          {tr("fail_getting_device")}
        </Alert>
      )}
      <VoiceControlsContainer />
    </div>
  );
}
